import React, { useContext } from 'react';
import { Button, SingleDatePicker, RangeDatePicker, SegmentedControls } from '@/shared/components';
import LanguageContext from '@/context/language';
import { useTranslation } from '@/app/i18n/client';

type Value = Object;
interface IProps {
  clearFilters: () => void;
  setRangeSelector: any;
  isRangeSelector: string;
  singleValue: string;
  setSingleValue: any;
  startDate: any;
  setStartDate: any;
  endDate: any;
  setEndDate: any;
}

export default function RangeSelector(props: IProps) {
  const {
    isRangeSelector,
    setRangeSelector,
    singleValue,
    setSingleValue,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  } = props;
  const { lang } = useContext(LanguageContext);
  const { t } = useTranslation(lang, 'orderhistory');

  return (
    <div>
      <p className="font-normal my-4">{t('order.data.range')}</p>
      <div className="flex md:inline-flex sm:inline-flex sm:flex-col md:flex-col">
        <div className="flex md:inline-flex sm:inline-flex sm:flex-col">
          <div className="flex mr-4 md:w-1/2 sm:w-full mt-2">
            <SegmentedControls
              options={[
                { label: t('range'), value: 'range' },
                { label: t('single.day'), value: 'single' },
              ]}
              uniqueKey={'rangeselector'}
              onChange={(e) => {
                setRangeSelector(e);
              }}
              selected={isRangeSelector}
              className="w-full sm:w-full md:w-full"
              childClassName="w-[150px]"
            ></SegmentedControls>
          </div>
          <div className="flex mr-4 my-auto md:w-1/2 sm:w-full mt-2">
            {isRangeSelector !== 'range' && (
              <SingleDatePicker
                lang={lang}
                singleDate={singleValue}
                placeholder="Select a Date"
                onChange={(value) => setSingleValue(value)}
                className="sm:min-w-min md:min-w-[150px]"
              ></SingleDatePicker>
            )}
            {isRangeSelector === 'range' && (
              <RangeDatePicker
                lang={lang}
                fromDate={startDate}
                toDate={endDate}
                placeholder="yyyy-mm-dd"
                joinText={t('range.to')}
                onFromChange={(value) => setStartDate(value)}
                onToChange={(value) => setEndDate(value)}
                className="sm:min-w-fit md:min-w-[100px] min-w-[100px]"
              ></RangeDatePicker>
            )}
          </div>
        </div>
        <div className="flex my-auto sm:w-full mt-2">
          <Button
            className="ml-auto sm:ml-0 md:ml-0"
            label={t('clear')}
            onClick={() => {
              setSingleValue('');
              setStartDate('');
              setEndDate('');
              props.clearFilters();
            }}
            type="outline"
          />
        </div>
      </div>
    </div>
  );
}
